import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "page-home" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = {
  key: 0,
  class: "top-alert"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("切換至當前版本")
const _hoisted_5 = { class: "top-form" }
const _hoisted_6 = { class: "form-box" }
const _hoisted_7 = { class: "btmGroup" }
const _hoisted_8 = { class: "historyGroup" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 近一年度歷史資料 ")
const _hoisted_10 = { class: "mid" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "月度截點", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "僅展示歷史截點時間前所產生之數據紀錄", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_FieldTimeOutlined = _resolveComponent("FieldTimeOutlined")!
  const _component_TextView = _resolveComponent("TextView")!
  const _component_HomeTable = _resolveComponent("HomeTable")!
  const _component_klook_icon = _resolveComponent("klook-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        (_ctx.data.visibleTopAlert)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_a_alert, {
                message: "當前查看為歷史數據, 如需查看最新數據請切換回當前版本",
                type: "warning",
                closable: "",
                onClose: _ctx.switchDefaultVersion
              }, {
                closeText: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _ctx.switchDefaultVersion,
                    type: "dashed"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["onClose"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_form, {
              layout: 'vertical',
              model: _ctx.form,
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      span: 8,
                      style: {"padding-right":"24px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.$t('75668')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_range_picker, {
                              placeholder: ['开始时间', '结束时间'],
                              ranges: 
                      _ctx.data.visibleTopAlert
                        ? {}
                        : {
                            [_ctx.$t('75655')]: [_ctx.dayjs().subtract(1, 'day'), _ctx.dayjs().subtract(1, 'day')],
                            [_ctx.$t('75656')]: [_ctx.dayjs().subtract(1, 'day').startOf('month'), _ctx.dayjs().subtract(1, 'day')],
                            [_ctx.$t('75657')]: [_ctx.dayjs().subtract(1, 'year'), _ctx.dayjs().subtract(1, 'day')]
                          }
                    ,
                              format: "YYYY-MM-DD",
                              value: _ctx.form.time,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.time) = $event)),
                              style: {"width":"100%"},
                              dropdownClassName: "timesRange",
                              "disabled-date": _ctx.disabledDate,
                              onCalendarChange: _ctx.cacheChange,
                              onChange: _ctx.cacheChange,
                              onOpenChange: _ctx.openChange,
                              allowClear: false
                            }, null, 8, ["ranges", "value", "disabled-date", "onCalendarChange", "onChange", "onOpenChange"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      span: 8,
                      style: {"padding-right":"24px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.$t('75667')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.form.booking_no,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.booking_no) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      span: 8,
                      style: {"padding-right":"20px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.$t('75669')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.form.category_id,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.category_id) = $event)),
                              mode: "multiple",
                              style: {"width":"100%"},
                              "filter-option": (input, option) => option.name.includes(input)
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: item.id,
                                    name: item.name,
                                    value: item.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["name", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "filter-option"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_button, {
                type: "primary",
                class: "minMarginR",
                onClick: _ctx.onSearch,
                loading: _ctx.data.searchLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('75653')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                onClick: _ctx.onReset,
                loading: _ctx.data.resetLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('75654')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, "數據截止更新時間：" + _toDisplayString(_ctx.data.visibleTopAlert ? _ctx.data.selectVersionDay : _ctx.data.currentTime), 1),
            _createElementVNode("span", {
              class: "history-btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.viewHistoricalVersion && _ctx.viewHistoricalVersion(...args)))
            }, [
              _createVNode(_component_FieldTimeOutlined),
              _hoisted_9
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_10, [
        _createVNode(_component_TextView, {
          res: _ctx.res,
          pagination: _ctx.pagination
        }, null, 8, ["res", "pagination"])
      ]),
      _createElementVNode("section", _hoisted_11, [
        _createVNode(_component_HomeTable, {
          list: _ctx.list,
          onOnChange: _ctx.onChange,
          pagination: _ctx.pagination,
          currency: _ctx.res.currency,
          onExportFunc: _ctx.exportFunc,
          exportLoading: _ctx.exportObj.loading
        }, null, 8, ["list", "onOnChange", "pagination", "currency", "onExportFunc", "exportLoading"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.data.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.visible) = $event))
    }, {
      title: _withCtx(() => [
        _hoisted_12,
        _createVNode(_component_a_tooltip, { placement: "top" }, {
          title: _withCtx(() => [
            _hoisted_13
          ]),
          default: _withCtx(() => [
            _createVNode(_component_klook_icon, {
              class: "historiy-info",
              type: 'info',
              size: [14, 14]
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.didSelectHistoricalVersion,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('75592')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_cascader, {
          value: _ctx.data.selectVersion,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.selectVersion) = $event)),
          "field-names": { label: 'version', value: 'version', children: 'items' },
          options: _ctx.historiyList,
          "show-search": { versionFilter: _ctx.versionFilter },
          placeholder: "Select verision",
          onChange: _ctx.changeHistoricalVersion
        }, null, 8, ["value", "options", "show-search", "onChange"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}